import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import OutsideClickHandler from 'react-outside-click-handler';
import AttendanceDetailView from './AttendanceDetailView';
import { Creators as courseClassAttendanceActions } from '../../../../../../../../domain/useCases/courses/getClassAttendance';
import TextHelper from '@/core/helpers/TextHelper';

interface AttendanceDetailViewControllerProps {
  setShowAttendance: (set: boolean) => void;
  courseTitle: string;
  catalogNumber: string;
  sectionId: string;
  selectPeriod: string;
}
const AttendanceDetailViewController = ({
  setShowAttendance,
  courseTitle,
  catalogNumber,
  sectionId,
  selectPeriod
}: AttendanceDetailViewControllerProps) => {
  const dispatch = useDispatch();
  const { data, isLoading, error } = useSelector(
    (state: any) => state.classAttendance
  );
  const handelOut = () => {
    setShowAttendance(false);
  };

  useEffect(() => {
    dispatch(
      courseClassAttendanceActions.getClassAttendance(selectPeriod, sectionId)
    );
    return () => {
      dispatch(courseClassAttendanceActions.getClassAttendanceClear());
    };
  }, []);

  const titleFormatted = () =>
    `${TextHelper.fixRomans(
      TextHelper.capitalize(courseTitle, false, true)
    )} (${catalogNumber.charAt(0)}${catalogNumber.substring(
      6,
      catalogNumber.length
    )})`;

  return (
    <div
      style={{
        background: 'rgb(40 48 68 / 60%)',
        position: 'fixed',
        left: 0,
        right: 0,
        top: 0,
        bottom: 0,
        zIndex: 99,
        height: '100%'
      }}
    >
      <OutsideClickHandler onOutsideClick={handelOut}>
        <AttendanceDetailView
          attendanceData={data}
          setShowAttendance={setShowAttendance}
          courseTitle={titleFormatted()}
          isLoading={isLoading}
          error={error}
        />
      </OutsideClickHandler>
    </div>
  );
};

export default AttendanceDetailViewController;
